if (!customElements.get('product-form')) {
  const injectLink = (brand) => {
    const { onlineStoreUrl, name } = brand
    
    // Find the vendor name of the product, delete it, replace it with a link element that links to the brand page.
    const brandElement = document.querySelector('.product__text')
    brandElement.innerHTML = `<a href="${onlineStoreUrl}">${name}</a>`
  }
  
  /**
   * Fetched the list of all brands, and injects the link to the brand's page
   * @param vendorName - The vendor of the product
   * @note Ideally we won't be doing this on the client side every page load, this is a hacky way for now.
   */
  const getBrands = (vendorName) => {
    // Get all brands list
    fetch('https://thecanvasglobal.myshopify.com/api/2024-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token':
          'a58d9cef05f7c85d1e7a6bade51c6969',
        'Accept': "application/json"
      },
      body: JSON.stringify({
        query: `
          query readMetaObjects {
            metaobjects(type:"brand", first:150){
              edges {
                node {
                  fields {
                    key
                    value
                  }
                  onlineStoreUrl
                }
              }
            }
          }
        `,
        variables: {}
      })
    })
      .then((res) => res.text())
      .then((res) => {
        if(!res) {
          console.log("Unable to fetch brands")
        } else {
          const raw = JSON.parse(res);
          const data = raw?.data?.metaobjects?.edges
  
          // Find the brand page that corresponds to the vendor name
          for (let i = 0; i < data.length; ++i) {
            const { id, onlineStoreUrl, fields } = data[i].node
            let name
            for(let i = 0; i < fields.length; ++i) {
              const field = fields[i]
              if(field.key === "brand_name") {
                name = field.value
              }
            }
            // If the brand name is found, inject the link to the brand page
            if(name && name.toLowerCase() === vendorName.toLowerCase()) {
              const brand = {
                id,
                onlineStoreUrl,
                name,
              }
              injectLink(brand)
              return
            }
          }
        }
      });
  };
  
  function addBrandLink() {
    const brandElement = document.querySelector('.product__text')
    const brandName = brandElement.innerHTML.trim()
    getBrands(brandName);
    document.addEventListener("shopify:section:load", () => getBrands(brandName));
  }
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';

      addBrandLink();
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
